import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppShell } from '@/components/app-shell';
import { DashboardPage } from '@/pages/dashboard-page';
import { ProductsPage } from '@/pages/products-page';
import { AddProductPage } from '@/pages/add-product-page';
import { ProductPage } from '@/pages/product-page';
import { CollectionsPage } from '@/pages/collections-page';
import { SettingsPage } from '@/pages/settings-page';
import { NotFoundPage } from '@/pages/not-found-page';
import { PrivateGate } from '@/components/private-gate';
import { QueryPage, EditQueryPage } from '@/pages/query-pages';
import '@/styles.css';

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } } });
const router = createBrowserRouter([{ element: <PrivateGate><AppShell /></PrivateGate>, children: [
  { path: '/', element: <DashboardPage /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/products/:productId', element: <ProductPage /> },
  { path: '/products/:productId/edit', element: <AddProductPage editing /> },
  { path: '/queries/:queryId', element: <QueryPage /> },
  { path: '/queries/:queryId/edit', element: <EditQueryPage /> },
  { path: '/add', element: <AddProductPage /> },
  { path: '/collections', element: <CollectionsPage /> },
  { path: '/settings', element: <SettingsPage /> },
  { path: '*', element: <NotFoundPage /> },
]}]);

createRoot(document.getElementById('root')!).render(<StrictMode><QueryClientProvider client={queryClient}><RouterProvider router={router} /><Toaster richColors position="top-right" /></QueryClientProvider></StrictMode>);

if ('serviceWorker' in navigator && import.meta.env.PROD) window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js'));
